import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Lock, User, AlertCircle, Loader2 } from 'lucide-react';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import logo from '../../assets/images/logos.png';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAdminAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const res = await login(username, password);
    if (res.ok) {
      navigate('/admin/chi-phi');
    } else {
      setError(res.message || 'Tên đăng nhập hoặc mật khẩu không đúng');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-blob red" />
      <div className="login-blob blue" />

      <div className="login-card">
        <img src={logo} alt="TUKI GROUP" className="login-logo" />
        <h1 className="login-title">Đăng nhập quản trị</h1>
        <p className="login-sub">Nhập tài khoản để tiếp tục</p>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className="alert alert-error">
              <AlertCircle size={16} />
              {error}
            </div>
          )}

          <div className="field">
            <label className="field-label">Tên đăng nhập</label>
            <div className="login-input-wrap">
              <User size={18} className="lead-icon" />
              <input
                className="input"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Nhập tên đăng nhập"
                required
                autoComplete="username"
              />
            </div>
          </div>

          <div className="field">
            <label className="field-label">Mật khẩu</label>
            <div className="login-input-wrap has-trail">
              <Lock size={18} className="lead-icon" />
              <input
                className="input"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Nhập mật khẩu"
                required
                autoComplete="current-password"
              />
              <button type="button" className="trail-btn" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <button type="submit" className="btn btn-primary btn-block login-submit" disabled={loading}>
            {loading ? (
              <>
                <Loader2 size={18} className="spin" /> Đang đăng nhập...
              </>
            ) : (
              <>
                <Lock size={18} /> Đăng nhập
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
